<template>
  <div>
    <common ref="common"/>
    <div class="d-flex align-center">
      <v-btn color="red" text rounded x-large @click="checkEnablePaymentGateway(true,dueTotal)">
        Pending ₹{{ dueTotal.toFixed(2) }} <v-btn class="ma-2" v-if='dueTotal>0'  color="primary" small @click="checkEnablePaymentGateway(true,dueTotal)">Pay</v-btn>
      </v-btn>
      <v-spacer></v-spacer>
      <v-chip
        class="trcs-chip"
        color="primary"
        variant="outlined"
        @click="show = !show"
      >
        <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
      </v-chip>
    </div>
    <v-expand-transition>
      <v-tabs v-model="selectedTab" centered color="primary" grow v-show="show">
        <v-tab style="font-size: 12px;">Transactions</v-tab>
        <v-tab style="font-size: 12px;">Pending</v-tab>
        <v-tab-item>
          <RecentTransactions @loadingChange="loadingChange" />
        </v-tab-item>
        <v-tab-item>
          <UpcomingDues
            @updateDueTotal="updateDueTotal"
            @getPaymentConfirmation="checkEnablePaymentGateway"
            @loadingChange="loadingChange"
            :userModel="userModel"
          />
        </v-tab-item>
      </v-tabs>
    </v-expand-transition>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
export default {
  components: {
    RecentTransactions: () =>
      import(
        "@/components/wesupport/dashboardComponents/RecentTransactions.vue"
      ),
    UpcomingDues: () =>
      import("@/components/wesupport/dashboardComponents/UpcomingDues.vue"),
    common: () => import("@/components/tools/common.vue")
  },
  data: () => ({
    selectedTab:1,
    dueTotal: 0,
    show: true,
    paymentGatewayEnabled:""
  }),
  props:{
    userModel:{
      type:Object,
      required:true
    }
  },
  methods: {
    loadingChange(v) {
      this.$emit("loadingChange", v);
    },
    updateDueTotal(t) {
      this.dueTotal = t;
    },
    checkEnablePaymentGateway(pending=false,amt) {
      var self = this;
      var common = this.$refs.common;
      this.settingsQModel = {
        module: "PaymentGateway",
        submodule: "CC_Avenue",
        setting: "Enable",
        value: null,
      };
      var url = "/api/wesupport/GeneralMaster/getSettings";
      callApi(url, "post", self.settingsQModel)
        .then((response) => {
          self.paymentGatewayEnabled = JSON.parse(
            response.data.data.toLowerCase()
          );
          // self.paymentGatewayEnabled=true;
          if(self.paymentGatewayEnabled){
        this.getPaymentConfirmation(pending,amt);
      }else{
        this.$refs.common.showSnackBar("This feature will be made available soon...","warn")
      }
        })
        .catch((error) => {
          // console.log("Error :" + error);
          common.ManageResponse(error.response);
        });
    },
    getPaymentConfirmation(pending=false,amt){
      this.$emit("getPaymentConfirmation",pending, amt);      
    }
  },
};
</script>
<style>
.trcs-chip{
  padding: 0 8px !important;
}
</style>
